import React from "react";
import BehaviourBarGraph from "../BehaviourBarGraph.jsx";
import { formatDuration } from "@signolteam/shared/units-of-measure";

let defaultMetadata = {
  time_diff_departure_scheduled_departure_min: 8,
};

export const behaviourMetadataFields = Object.keys(defaultMetadata);
export default function graph({
  metadata = defaultMetadata,
  missingDataMsg,
  bvrColour,
  isExample,
}) {
  const delay = Number(metadata["time_diff_departure_scheduled_departure_min"]);
  const threshold = 10;

  if (isNaN(delay) || isNaN(threshold)) {
    return (
      <div className="relative text-center my-6 mx-auto text-2xl fill-current">
        {missingDataMsg}
      </div>
    );
  }

  if (delay < 0) {
    return (
      <div className="w-full flex flex-row justify-center items-center my-6">
        <div className={`bg-${bvrColour.name}-100 p-6`}>
          {
            "This OTD success is because you departed earlier than the scheduled departure time."
          }
        </div>
      </div>
    );
  }

  const data = [
    {
      name: "Delay in letting go of all lines",
      mobileName: "Label",
      beforeThreshold: delay > threshold ? threshold : delay,
      afterThreshold: delay > threshold ? delay - threshold : 0,
      underThresholdColour:
        delay <= threshold ? bvrColour.codes["500"] : bvrColour.codes["200"],
      overThresholdColour: bvrColour.codes["900"],
    },
  ];

  const domainMin = 0;
  const domainMax =
    Math.max(threshold, delay) + (Math.max(threshold, delay) / 100) * 20; // add 20% for label space
  const domain = [domainMin, domainMax];

  const mobileMargin = delay < threshold ? 0.05 * threshold : 0.05 * delay;
  const mobileDomainMax =
    delay < threshold
      ? Math.ceil(threshold + mobileMargin)
      : Math.ceil(delay + mobileMargin);
  const mobileDomain = [domainMin, mobileDomainMax];

  const thresholdLineColour = bvrColour.codes["900"];

  const ticks = [];
  for (let i = 0; i < domainMax; i++) {
    ticks.push(i + 1);
  }

  return (
    <BehaviourBarGraph
      data={data}
      threshold={threshold}
      thresholdLabel={`Signol threshold (${
        formatDuration(threshold, { boundaryValues: [0, delay * 60] })
          .formattedValue
      } from scheduled departure)`}
      mobileDomain={mobileDomain}
      domain={domain}
      refLineColour={thresholdLineColour}
      success={!(threshold < delay)}
      axisLabel={"Time (minutes)"}
      hideYLine={true}
      hideNum={true}
      barLabelFormatter={() =>
        `${formatDuration(delay * 60, { boundaryValues: [0, threshold * 60] }).formattedValue}`
      }
      ticks={ticks}
      isExample={isExample}
    />
  );
}
